var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
let RuleToast = class RuleToast extends Vue {
};
__decorate([
    State
], RuleToast.prototype, "toastVisible", void 0);
__decorate([
    Mutation
], RuleToast.prototype, "TOGGLE_TOAST", void 0);
__decorate([
    Mutation
], RuleToast.prototype, "SET_AGREEMENT", void 0);
RuleToast = __decorate([
    Component
], RuleToast);
export default RuleToast;
